<h1 mat-dialog-title>{{ edit ? 'Labor-/Diagnostikartikel bearbeiten' : 'Labor-/Diagnostikartikel hinzufügen' }}</h1>

<mat-dialog-content style="padding: 24px; min-height: 500px">
    <!-- Artikeltyp-Auswahl über Radio-Buttons -->
    <div style="margin-bottom: 24px; padding: 16px; background-color: #f5f5f5; border-radius: 8px">
        <mat-radio-group [formControl]="artikeltypCtrl" (change)="artikeltypChanged()" style="display: flex; gap: 32px">
            <mat-radio-button value="labor">
                <mat-icon style="vertical-align: middle; margin-right: 8px; font-size: 20px; width: 20px; height: 20px">science</mat-icon>
                Laborartikel
            </mat-radio-button>
            <mat-radio-button value="diagnostik">
                <mat-icon style="vertical-align: middle; margin-right: 8px; font-size: 20px; width: 20px; height: 20px">biotech</mat-icon>
                Diagnostikartikel
            </mat-radio-button>
        </mat-radio-group>
        <p style="margin: 12px 0 0; color: #666; font-size: 13px">
            Konten werden automatisch gesetzt (Tab Rechnungswesen): Diagnostik = Verbrauch,
            Labor mit Praxis-Lieferant (Kiene) oder Stückliste = eigenes Labor,
            anderer Lieferant = Fremdlabor. Dort können Sie die Konten bei Bedarf überschreiben.
        </p>
    </div>

    <!-- Haupttabs: Grunddaten / Stückliste -->
    <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)" style="width: 100%">
        <!-- Tab: Grunddaten -->
        <mat-tab label="Grunddaten">
            <div style="padding: 24px 0; display: flex; flex-direction: column; gap: 20px">
                <!-- Bezeichnung und Artikelname auf Befund in einer Reihe -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
                    <mat-form-field appearance="outline">
            <mat-label>Bezeichnung *</mat-label>
            <input matInput [formControl]="bezeichnungCtrl" placeholder="Bezeichnung" required />
            <mat-error *ngIf="bezeichnungCtrl.hasError('required')">Bezeichnung ist erforderlich</mat-error>
        </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Artikelname auf Befund</mat-label>
                        <input matInput [formControl]="bezeichnungBefundCtrl" placeholder="Name auf Befund (optional)" />
                        <mat-hint>Alternative Bezeichnung, die auf Befunden angezeigt wird</mat-hint>
        </mat-form-field>
                </div>

                <mat-form-field appearance="outline">
                    <mat-label>Kommentar</mat-label>
                    <textarea matInput [formControl]="kommentarCtrl" rows="2" maxlength="500" placeholder="Zusätzliche Infos"></textarea>
                    <mat-hint>Bis zu 500 Zeichen</mat-hint>
                    <mat-error *ngIf="kommentarCtrl.hasError('maxlength')">Höchstens 500 Zeichen</mat-error>
                </mat-form-field>

                <!-- Kürzel, Einheit und Gebinde -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
                    <mat-form-field appearance="outline">
                        <mat-label>Kürzel</mat-label>
                        <input matInput [formControl]="kuerzelCtrl" placeholder="Kürzel" />
                    </mat-form-field>

                    <kiene-einheit-selector
                        #einheitSelector
                        [preselected]="selectedEinheit"
                        (changed)="setEinheit($event)"
                        info="Zähleinheit des Inhalts, zum Beispiel Stück oder ml. Steht hinter dem Inhalt je Gebinde."
                    ></kiene-einheit-selector>
                </div>

                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
                    <mat-form-field appearance="outline">
                        <mat-label>Lagereinheit</mat-label>
                        <input matInput [formControl]="lagereinheitCtrl" maxlength="10" placeholder="z. B. Box" />
                        <mat-icon
                            matSuffix
                            class="field-info"
                            matTooltip="Wie das Gebinde heißt, das bestellt und gelagert wird, zum Beispiel Box oder Karton. Die Menge im Warenkorb zählt diese Einheit."
                            matTooltipPosition="above"
                        >info</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Gebindegröße</mat-label>
                        <input matInput type="number" [formControl]="gebindegroesseCtrl" placeholder="50" min="1" step="1" />
                        <mat-icon
                            matSuffix
                            class="field-info"
                            matTooltip="Wie viele Einheiten in einem Gebinde sind. Lagereinheit Box und Gebindegröße 50 ergeben auf der Bestellung „1 Box à 50 Stück“."
                            matTooltipPosition="above"
                        >info</mat-icon>
                    </mat-form-field>
                </div>

                <mat-form-field appearance="outline">
                    <mat-label>Inhalt je Gebinde</mat-label>
                    <input matInput type="number" [formControl]="mengeCtrl" placeholder="1" step="0.01" />
                    <mat-icon
                        matSuffix
                        class="field-info"
                        matTooltip="Wie viel von der Einheit in einem Gebinde steckt, zum Beispiel 50. Diese Zahl erscheint im Artikelnamen. Oft gleich der Gebindegröße."
                        matTooltipPosition="above"
                    >info</mat-icon>
                </mat-form-field>

                <div style="display: grid; grid-template-columns: 1fr auto; gap: 16px; align-items: start">
                    <mat-form-field appearance="outline">
                        <mat-label>Mindestbestellmenge</mat-label>
                        <input matInput type="number" [formControl]="mindestbestellmengeCtrl" placeholder="z. B. 4" min="1" step="1" />
                        <mat-icon
                            matSuffix
                            class="field-info"
                            matTooltip="Kleinste Menge, die beim Lieferanten bestellt wird, gezählt in der Lagereinheit. Beim normalen Artikel ist das die Bestellmenge, zum Beispiel 4. Leer lassen, wenn es keine Untergrenze gibt."
                            matTooltipPosition="above"
                        >info</mat-icon>
                        <mat-hint>in {{ packLabel() }}</mat-hint>
                    </mat-form-field>
                    <button mat-stroked-button type="button" class="vorschau-button" (click)="openBestellvorschau()">
                        <mat-icon>picture_as_pdf</mat-icon>
                        Vorschau
                    </button>
                </div>

                <!-- Lieferant, Artikelnr. Lieferant und EAN -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
                    <div style="display: flex; align-items: flex-start; gap: 8px">
                        <div style="flex: 1">
            <kiene-autocomplete
                #lieferantAutocomplete
                [apiUrl]="'lieferant/'"
                [displayField]="'bezeichnung'"
                                [placeholder]="fremdlaborCtrl.value ? 'Fremdlabor' : 'Lieferant (optional)'"
                [focus]="false"
                [kieneObject]="selectedLieferant"
                (elementSelected)="setLieferant($event)"
                (deleteSelected)="lieferantDeleted()"
                [showDeleteButton]="true"
            ></kiene-autocomplete>
        </div>
                        <button
                            mat-icon-button
                            type="button"
                            (click)="addNewLieferant()"
                            matTooltip="Neuen Lieferanten hinzufügen"
                            style="margin-top: 8px; flex-shrink: 0"
                            color="primary"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Artikelnr. Lieferant</mat-label>
                        <input matInput [formControl]="artikelnrLieferantCtrl" placeholder="z.B. 20900" />
                        <mat-hint>Externe Artikelnr. des Lieferanten (keine Eindeutigkeit)</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>EAN</mat-label>
                        <input matInput [formControl]="eanCtrl" placeholder="EAN" />
                    </mat-form-field>
                </div>

                <!-- Idexx-Felder (nur für Laborartikel, direkt unter Lieferant) -->
                <div *ngIf="artikeltypCtrl.value === 'labor'" style="margin-top: 16px">
                    <div style="display: flex; align-items: center; padding: 12px; background-color: #f5f5f5; border-radius: 4px; margin-bottom: 16px">
                        <mat-checkbox [formControl]="idexxCtrl"> Idexx aktivieren </mat-checkbox>
                        <mat-icon style="margin-left: 8px; color: #666; font-size: 18px" matTooltip="Idexx-Integration für Laborartikel aktivieren">info</mat-icon>
                    </div>
                    <div *ngIf="idexxCtrl.value" style="display: flex; flex-direction: column; gap: 16px">
                        <mat-form-field appearance="outline">
                            <mat-label>Messgröße</mat-label>
                            <input matInput [formControl]="idexxMessgroesseCtrl" placeholder="z.B. mg/dL, mmol/L, %" />
                            <mat-hint>Einheit der Messgröße (z.B. mg/dL, mmol/L, %)</mat-hint>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>PDF Beschreibung</mat-label>
                            <textarea matInput [formControl]="idexxPdfBeschreibungCtrl" rows="3" placeholder="Beschreibung, die im PDF-Befund angezeigt wird"></textarea>
                            <mat-hint>Text, der im PDF-Befund als Beschreibung angezeigt wird</mat-hint>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>PDF Tabellentext</mat-label>
                            <textarea matInput [formControl]="idexxPdfTabellenTextCtrl" rows="3" placeholder="Text für die Tabelle im PDF-Befund"></textarea>
                            <mat-hint>Text, der in der Tabelle des PDF-Befunds angezeigt wird</mat-hint>
                        </mat-form-field>
                    </div>
                </div>

                <div *ngIf="artikeltypCtrl.value === 'labor'">
                    <div style="display: flex; align-items: center; padding: 12px; background-color: #f5f5f5; border-radius: 4px">
                        <mat-checkbox [formControl]="fremdlaborCtrl" (change)="fremdlaborChanged()">
                            Fremdlaborartikel
                        </mat-checkbox>
                        <mat-icon
                            style="margin-left: 8px; color: #666; font-size: 18px"
                            matTooltip="Externes Labor, nicht der eigene Betrieb. Der Artikel erscheint nicht in Bestellungen und läuft über den Untersuchungsauftrag."
                        >info</mat-icon>
                    </div>
                    <p style="margin: 8px 0 0; font-size: 12px; color: #666">
                        Haken setzen und das Fremdlabor auswählen. Stückliste und der eigene Betrieb gehen nicht.
                    </p>
                </div>

                <!-- Stückliste aktivieren (nur für Laborartikel) -->
                <div *ngIf="artikeltypCtrl.value === 'labor'">
                    <div style="display: flex; align-items: center; padding: 12px; background-color: #f5f5f5; border-radius: 4px; margin-bottom: 16px">
                        <mat-checkbox [formControl]="stuecklisteCtrl" (change)="stuecklisteChanged()">
                            Stückliste aktivieren
                        </mat-checkbox>
                        <mat-icon style="margin-left: 8px; color: #666; font-size: 18px" matTooltip="Artikel besteht aus mehreren Diagnostikartikeln. Der Einkaufspreis wird automatisch aus der Stückliste berechnet.">info</mat-icon>
                    </div>
                </div>

                <!-- Zwischenspeichern Button -->
                <div style="margin: 16px 0; padding-top: 16px; border-top: 1px solid #e0e0e0">
                    <button
                        mat-stroked-button
                        color="primary"
                        (click)="zwischenspeichern()"
                        [disabled]="isSaving || bezeichnungCtrl.invalid || (!stuecklisteCtrl.value && !einzelpreisCtrl.value)"
                        style="width: 100%"
                    >
                        <mat-icon style="vertical-align: middle; margin-right: 8px">save</mat-icon>
                        <span *ngIf="!isSaving">Zwischenspeichern</span>
                        <span *ngIf="isSaving">Wird gespeichert...</span>
                    </button>
                    <p style="margin: 8px 0 0 0; font-size: 12px; color: #666; text-align: center">
                        Artikel speichern, um Stückliste anzulegen
                    </p>
                </div>

                <!-- Preise -->
                <div>
                    <div style="padding: 16px; background-color: #f9f9f9; border-radius: 8px; border: 1px solid #e0e0e0">
                        <h3 style="margin: 0 0 16px 0; font-size: 16px; font-weight: 500">Preise</h3>

                        <!-- Preise ohne Stückliste -->
                        <div *ngIf="!stuecklisteCtrl.value">
                            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px">
                <!-- Einkaufspreis -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Einkaufspreis (€) *</mat-label>
                    <input
                        matInput
                        type="number"
                        step="0.01"
                        [formControl]="einzelpreisCtrl"
                                        placeholder="0.00"
                    />
                </mat-form-field>

                                <!-- Marge -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Handelsmarge (%)</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        [formControl]="margeCtrl"
                                        placeholder="20"
                                    />
                                    <mat-hint>Standard: 20% oder 30%, andere Werte möglich</mat-hint>
                </mat-form-field>

                <!-- Verkaufspreis -->
                                <mat-form-field appearance="outline">
                    <mat-label>Verkaufspreis (€)</mat-label>
                    <input
                        matInput
                        type="number"
                        step="0.01"
                        [formControl]="verkaufspreisCtrl"
                                        placeholder="0.00"
                                    />
                                    <mat-hint>Wird automatisch berechnet oder kann manuell angepasst werden</mat-hint>
                </mat-form-field>
            </div>

                            <!-- Hinweis: Einkaufspreis ohne Lieferant -->
                            <div
                                *ngIf="!selectedLieferant && einzelpreisCtrl.value"
                                style="margin-top: 12px; padding: 12px; background-color: #e3f2fd; border-radius: 4px"
                            >
                                <div style="display: flex; align-items: start">
                                    <mat-icon style="color: #1976d2; margin-right: 12px; margin-top: 2px">info</mat-icon>
                                    <div>
                                        <strong>Hinweis</strong>
                                        <p style="margin: 4px 0 0 0; font-size: 13px; color: #555">
                                            Ohne ausgewählten Lieferanten kann kein Einkaufspreis gespeichert werden.
                                        </p>
                                    </div>
                                </div>
                            </div>
        </div>

                        <!-- Preise mit Stückliste -->
                        <div *ngIf="stuecklisteCtrl.value">
                            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px">
                                <!-- Einkaufspreis aus Stückliste -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Einkaufspreis (€)</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        step="0.01"
                                        [formControl]="stuecklisteEinkaufspreisCtrl"
                                        placeholder="0.00"
                                        readonly
                                        [disabled]="true"
                                    />
                                    <mat-hint>Aus Stückliste berechnet</mat-hint>
                                </mat-form-field>

                                <!-- Marge -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Handelsmarge (%)</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        [formControl]="margeCtrl"
                                        placeholder="20"
                                    />
                                    <mat-hint>Standard: 20% oder 30%, andere Werte möglich</mat-hint>
                                </mat-form-field>

                                <!-- Verkaufspreis -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Verkaufspreis (€)</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        step="0.01"
                                        [formControl]="verkaufspreisCtrl"
                                        placeholder="0.00"
                                    />
                                    <mat-hint>Wird automatisch berechnet oder kann manuell angepasst werden</mat-hint>
                                </mat-form-field>
                            </div>
                            <div style="margin-top: 12px; padding: 12px; background-color: #e3f2fd; border-radius: 4px">
                                <div style="display: flex; align-items: start">
                                    <mat-icon style="color: #1976d2; margin-right: 12px; margin-top: 2px">info</mat-icon>
                                    <div>
                                        <strong>Stückliste aktiviert</strong>
                                        <p style="margin: 4px 0 0 0; font-size: 13px; color: #555">
                                            Der Einkaufspreis wird automatisch aus der Summe der Diagnostikartikel in der Stückliste berechnet.
                                            Bitte legen Sie die Stückliste im Tab "Stückliste" an.
                                            <br />
                                            <strong>Wichtig:</strong> Damit Sie die Stückliste anlegen können, muss der Artikel vorher einmal
                                            zwischengespeichert werden.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
            </div>
        </div>

        <!-- Gesperrt -->
        <mat-checkbox [formControl]="gesperrtCtrl"> Artikel gesperrt </mat-checkbox>
            </div>
        </mat-tab>

        <!-- Tab: Stückliste (nur für Laborartikel mit aktivierter Stückliste) -->
        <mat-tab label="Stückliste" *ngIf="artikeltypCtrl.value === 'labor' && stuecklisteCtrl.value">
            <div style="padding: 24px 0">
                <!-- NEU: Stückliste auch bei neuen Artikeln anzeigen (lokale Zwischenspeicherung) -->
                <div *ngIf="materialForStueckliste">
                    <ng-container *ngIf="hasPermissionForStueckliste(); else noStuecklistePermission">
                        <kiene-stueckliste
                            [material]="materialForStueckliste"
                            [hideTierartAnwendungDiagnoseDosierung]="true"
                            [hideRabatt]="true"
                            [nurDiagnostikArtikel]="true"
                            (reload)="onStuecklisteReload()"
                        ></kiene-stueckliste>
                    </ng-container>
                </div>

                <!-- Fallback, falls Berechtigung 4401 fehlt -->
                <ng-template #noStuecklistePermission>
                    <div style="padding: 40px; text-align: center; color: #666">
                        <mat-icon
                            style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 16px; color: #999"
                        >
                            lock
                        </mat-icon>
                        <p style="font-size: 16px; margin: 0 0 8px 0">
                            Sie haben keine Berechtigung, die Stückliste dieses Artikels anzuzeigen oder zu bearbeiten
                            (Recht 4401 erforderlich).
                        </p>
                    </div>
                </ng-template>
            </div>
        </mat-tab>

        <!-- Tab: Rechnungswesen immer zuletzt -->
        <mat-tab label="Rechnungswesen">
            <div style="padding: 24px 0; display: flex; flex-direction: column; gap: 16px; max-width: 640px">
                <p style="margin: 0; color: #666; font-size: 13px; line-height: 1.45">
                    {{ kontenHinweis() }}
                    <span *ngIf="kontenManuell" style="display: block; margin-top: 8px; color: #b35c00">
                        Konten wurden manuell gesetzt. Wechsel von Typ, Lieferant oder Stückliste setzt den Vorschlag
                        wieder neu.
                    </span>
                </p>
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
                    <mat-form-field appearance="outline">
                        <mat-label>Aufwandskonto</mat-label>
                        <input
                            matInput
                            [formControl]="buchungskontoCtrl"
                            (input)="onKontenManuellGeaendert()"
                            placeholder="z.B. 3402"
                        />
                        <mat-hint>Einkauf / Verbrauch</mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Erlöskonto</mat-label>
                        <input
                            matInput
                            [formControl]="erloeskontoCtrl"
                            (input)="onKontenManuellGeaendert()"
                            placeholder="z.B. 8402"
                        />
                        <mat-hint>Verkauf (Diagnostik leer)</mat-hint>
                    </mat-form-field>
                </div>
                <div>
                    <button mat-stroked-button type="button" color="primary" (click)="refreshKontenVorschlag(true)">
                        <mat-icon style="margin-right: 4px; vertical-align: middle">refresh</mat-icon>
                        Vorschlag neu setzen
                    </button>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 16px 24px; border-top: 1px solid #e0e0e0" *ngIf="!isStuecklisteTabSelected()">
    <button mat-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    <button
        mat-raised-button
        color="primary"
        (click)="save()"
        [disabled]="isSaving || bezeichnungCtrl.invalid"
        cdkFocusInitial
    >
        <mat-icon *ngIf="!isSaving" style="vertical-align: middle; margin-right: 4px">save</mat-icon>
        <span *ngIf="!isSaving">{{ edit ? 'Speichern' : 'Erstellen' }}</span>
        <span *ngIf="isSaving">Wird gespeichert...</span>
    </button>
</mat-dialog-actions>
